import DesktopLanding from '../../MyComponents/Landing/DesktopLanding';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { ForTutoringFeaturesDesktop } from './TutoringFeatures/ForTutoringFeaturesDesktop';
import Typography from '@material-ui/core/Typography';
import { FormattedMessage } from 'react-intl';
import { VIDEO_URLS } from '../../constants';
import { StartGroupButton } from '../../MyComponents/StartGroupButton/StartGroupButton';

const useStyles = makeStyles(() => ({
    desktopContainer: {
        position: 'relative',
        marginBottom: '-10rem',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    bottomGreenPaper: {
        background: 'rgba(8, 170, 180, 0.16)',
        borderRadius: '0rem 0rem 2rem 2rem',
        height: '2rem',
        width: '90%',
    },
}));

const ForTutoringDesktop = ({ handleOpen, language }) => {
    const classes = useStyles();

    const setCreateGroupPath = () => {
        window.localStorage.setItem('pathBeforeLogin', '/creategroup');
    };

    return (
        <>
            <DesktopLanding videoUrl={VIDEO_URLS['tutoring'][language.toUpperCase()]} needsBackground={false}>
                <div style={{ zIndex: '1', whiteSpace: 'nowrap', marginTop: '3rem' }}>
                    <Typography variant="h1">
                        <FormattedMessage
                            id={'redesign.page.home.forTutoring.tagline.v2'}
                            values={{
                                b: (chunks) => (
                                    <b>
                                        {chunks}
                                        <br></br>
                                    </b>
                                ),
                            }}
                        />
                    </Typography>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'bottom',
                            paddingTop: '1rem',
                        }}
                    >
                        <StartGroupButton
                            handleOpen={() => {
                                handleOpen(false);
                                setCreateGroupPath();
                            }}
                        />
                    </div>
                </div>
            </DesktopLanding>
            <div className={classes.desktopContainer}>
                <ForTutoringFeaturesDesktop
                    handleOpen={() => {
                        handleOpen(false);
                        setCreateGroupPath();
                    }}
                />
                <div className={classes.bottomGreenPaper} />
            </div>
        </>
    );
};

export default ForTutoringDesktop;
